var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Adsense',{staticClass:"adsbygoogle",attrs:{"data-ad-client":"ca-pub-7038131727768741","data-language":"ko","data-ad-slot":_vm.adSlot,"ins-style":_vm.style}})}
var staticRenderFns = []

export { render, staticRenderFns }